import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Stack,
  Text,
  Avatar,
  HStack,
  Textarea,
  Box,
  VisuallyHiddenInput,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  IconButton,
  Portal,
} from "@chakra-ui/react";
import React from "react";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { MdAttachFile } from "react-icons/md";
import { FiSend } from "react-icons/fi";
import { HiOutlineEmojiHappy } from "react-icons/hi";
import EmojiPicker from "emoji-picker-react";
import {BsEmojiSmile} from "react-icons/bs";

export default function ContactPopup() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [message, setMessage] = React.useState("");
  const inputRef = React.useRef();
  function handleEmojiClick(emojiData, event) {
    // setSelectedEmoji(emojiData);
    setMessage((prevState) => prevState + emojiData.emoji);
  }
  return (
    <>
      <Button
        bg="brand.500"
        borderRadius={10}
        color="white"
        px={10}
        py={6}
        _hover={{ bg: "brand.400", color: "white" }}
        onClick={onOpen}
      >
        Contact Me
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        size={{ base: "xs", sm: "sm", lg: "xl" }}
      >
        <ModalOverlay />
        <ModalContent py={3} maxHeight="80vh">
          <ModalCloseButton
            mt={5}
            mr={6}
            bg="#c5c5c5"
            color="white"
            borderRadius="20px"
          />
          <ModalBody overflowY="auto" maxHeight="100vh">
            <Stack py={2} gap={2}>
              <Stack alignItems="center" gap={2}>
                <Avatar
                  src="/images/marketplace-category/profile/profile-1.png"
                  size="xl"
                />
                <HStack color="#0079BC">
                  <Text fontWeight="bold">Logo Master</Text>
                  <BsFillCheckCircleFill color="#52B9F3" />
                </HStack>
              </Stack>
              <Textarea
                placeholder="Type your message here...."
                value={message}
                onChange={(e)=>{setMessage(prevState=>e.target.value)}}
                p={4}
                rows={4}
              />
              <Button
                justifyContent="start"
                variant="outline"
                w="min-content"
                pr={{ lg: 10 }}
              >
                <Text
                  fontWeight="medium"
                  fontSize={{ base: "10px",sm:"12px", lg: "16px" }}
                >
                  Hey logo master, can you help me with...
                </Text>
              </Button>
              <Button
                justifyContent="start"
                variant="outline"
                w="min-content"
                pr={{ lg: 10 }}
              >
                <Text
                  fontWeight="medium"
                  fontSize={{ base: "10px",sm:"12px", lg: "16px" }}
                >
                  Do you have any experience with...
                </Text>
              </Button>
              <Button
                justifyContent="start"
                variant="outline"
                w="min-content"
                pr={{ lg: 10 }}
              >
                <Text
                  fontWeight="medium"
                  fontSize={{ base: "10px",sm:"12px", lg: "16px" }}
                >
                  Do you think you can deliver an order by...
                </Text>
              </Button>
              <HStack color="#888" fontSize="22px">
                <Button bg="brand.500" color="white" px={6} onClick={()=>{setMessage("")}}>
                  <FiSend />
                  <Text pl={2}>Send</Text>
                </Button>
                <VisuallyHiddenInput ref={inputRef} type="file" />
                <Box
                  cursor="pointer"
                  onClick={() => {
                    inputRef.current.click();
                  }}
                >
                  <MdAttachFile />
                </Box>

                

                {/* Emoji button */}
                <Popover placement='top-start'>
                  <PopoverTrigger>
                    <IconButton variant="" minWidth={"min-content"}>
                    <HiOutlineEmojiHappy />
                    </IconButton>
                  </PopoverTrigger>

                    <PopoverContent w="fit-content">
                      <PopoverArrow />
                      <PopoverBody p={0}>
                        <EmojiPicker
                          onEmojiClick={handleEmojiClick}
                          width={"250px"}
                        />
                      </PopoverBody>
                    </PopoverContent>
                  
                </Popover>
              </HStack>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
